import { css } from '@emotion/react'
import { withPrefix } from 'gatsby'

export const fontStyles = css`
  @font-face {
    font-family: Colfax;
    src: url(${withPrefix('/fonts/ColfaxWebRegular.woff2')}) format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Colfax;
    src: url(${withPrefix('/fonts/ColfaxWebRegularItalic.woff2')})
      format('woff2');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: Colfax;
    src: url(${withPrefix('/fonts/ColfaxWebBold.woff2')}) format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Colfax;
    src: url(${withPrefix('/fonts/ColfaxWebMedium.woff2')}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
`
